export enum ScreenStartAnimationEnum {
  WITHOUT = "WITHOUT",
  WITHOUT_AND_BLUR_BACKGROUND = "WITHOUT_AND_BLUR_BACKGROUND",
  FROM_TOP = "FROM_TOP",
  FROM_BOTTOM = "FROM_BOTTOM",
  FROM_LEFT_TO_RIGHT = "FROM_LEFT_TO_RIGHT",
  FROM_RIGHT_TO_LEFT = "FROM_RIGHT_TO_LEFT",
}
